module.exports = __webpack_public_path__ + "static/media/Room types speed.eb5aac56.svg";